import React from "react";
import DelendDrawer from "../../../../components/AppBar/DelendDrawer";
import { Box } from "@mui/material";

import DragAndDropZone from "./DragAndDropZone";
import NFBoard from "./NFBoard";
import { useDispatch, useSelector } from "react-redux";
import { reset } from "../../../../store/uploadingFileSlice";

const UploadFileZone = ({ openSideBar, handleDrawerClose }) => {
  const dispatch = useDispatch();

  const { files, invoicesUploadSuccessfully } = useSelector(
    (state) => state.uploading
  );

  return (
    <Box>
      <DelendDrawer
        title={"Adicionar notas fiscais"}
        subtitle={
          "Faça upload do arquivo em XML das suas notas fiscais para simular a atencipação."
        }
        open={openSideBar}
        handleCloser={() => {
          handleDrawerClose(invoicesUploadSuccessfully);
          dispatch(reset());
        }}
      >
        {files.length === 0 ? (
          <DragAndDropZone />
        ) : (
          <NFBoard files={files} handleDrawerClose={handleDrawerClose} />
        )}
      </DelendDrawer>
    </Box>
  );
};

export default UploadFileZone;
